// @ts-ignore
import { DataTable as DataTableModule } from 'simple-datatables';

class DataTable {
  private el: HTMLElement;
  private table: any;

  constructor(element: HTMLElement) {
    this.el = element;
    this.init();
  }

  private init() {
    const cells = [...this.el.querySelectorAll('td')];
    cells.forEach(c => {
      if(c.querySelectorAll('p').length > 1) {
        c.classList.add('nowrap')
      }

      if(c.innerText.includes('-') && c.innerText !== '-') {
        c.innerHTML = c.innerText.replaceAll('-', '<br>');
        c.classList.add('nowrap')
      }
    })

    this.table = new DataTableModule(this.el, {
      paging: true,
      perPage: 10,
      labels: {
        noRows: (window as any).translations.table.noResults,
        placeholder: (window as any).translations.table.search,
      },
    });

    // Array.from(this.el.querySelectorAll('.dataTable-sorter')).forEach(
    //   (a: any) => {
    //     console.log(a);
    //     a.removeAttribute('href');
    //   },
    // );
  }
}

export default DataTable;
